<template>
    <crud-show :title="title" :open="open"  @close="$emit('close')">

        <v-card-text>
            <stock-transaction-show-data :item="item" />
        </v-card-text>

  </crud-show>
</template>

<script>
    import StockTransactionShowData from "./StockTransactionShowData";
    import {CrudShow} from '@dracul/common-frontend'
 
    export default {
        name: "StockTransactionShow",
        components: {CrudShow, StockTransactionShowData},
        props: {
            open: {type: Boolean, default: true},
            item: {type: Object, required: true}
        },
        data() {
            return {
                title: 'delivery.stockTransaction.showing',
            }
        },
    }
</script>

